import $ from 'jquery';
import CollectionFilter from './CollectionFilters';

export default () => {
  if ($('[data-collection-filters]').length === 0) { return; }

  $('[data-collection-filters]').each((i, collection_filter) => {
    const $collection_filter = $(collection_filter);

    if (!$collection_filter.attr('initialized')) {
      new CollectionFilter($collection_filter);
      $collection_filter.attr('initialized', true);
    }
  });
};
